// extracted by mini-css-extract-plugin
export default {"container":"landing_container__2dWta","wrapper":"landing_wrapper__Ddb-6"};